import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

export const getErrorText = (
  error: string,
  t: TTranslator<TLocalesKeys>
): string => {
  switch (error) {
    case 'PROMO_CODE_NOT_FOUND':
      return t('promo.validate.error_1');
    case 'PROMO_CODE_INACTIVE':
      return t('promo.validate.error_2');
    case 'PROMO_CODE_EXPIRED':
      return t('promo.validate.error_3');
    case 'PROMO_CODE_NOT_STARTED':
      return t('promo.validate.error_4');
    case 'PROMO_CODE_LIMIT_REACHED':
      return t('promo.validate.error_5');
    case 'PROMO_CODE_INVALID_SCOPE':
      return t('promo.validate.error_6');
    case 'PROMO_CODE_INVALID_CLIENT':
      return t('promo.validate.error_7');
    case 'PROMO_CODE_INVALID_TYPE':
      return t('promo.validate.error_8');
    case 'PROMO_CODE_NOT_APPLICABLE_TO_ITEMS':
      return t('promo.validate.error_9');
    case 'PROMO_CODE_REQUIRES_ITEMS':
      return t('promo.validate.error_10');
    default:
      return t('errors.promo.incorrect');
  }
};
